module.exports = __webpack_public_path__ + "overlook-studios/img/ben.png";